import { useEffect, useState } from 'react';

import { getById } from '../../../../services/configurationService';
import { UploadBySet } from '../UploadBySet/UploadBySet'
import { UploadByBulk } from '../UploadByBulk/UploadByBulk';
import { DescriptiveUpload } from '../DescriptiveUpload/DescriptiveUpload';
import { TypingUpload } from '../TypingUpload/TypingUpload';


export const ContentUpload = ({ drive, course, configurationId }) => {

    const [examType, setExamType] = useState(null);
    const [contentUploadMethod, setContentUploadMethod] = useState(null);

    useEffect(() => {
        if (configurationId) {
            const fetchConfiguration = async () => {
                try {
                    const res = await getById(configurationId);
                    if (res.code === 'OK') {
                        setExamType(res.data.examType);
                        setContentUploadMethod(res.data.contentUploadMethod);
                    }
                } catch (error) {
                    console.log('There is an error while getting configuration', error);
                }
            }
            fetchConfiguration();
        }
    }, [configurationId]);

    const renderComponent = () => {
        if (examType === 'MCQ') {
            return contentUploadMethod && contentUploadMethod === 'bulk'
                ? <UploadByBulk drive={drive} course={course} configurationId={configurationId}></UploadByBulk>
                : <UploadBySet drive={drive} course={course} configurationId={configurationId}></UploadBySet>
        } else if (examType === 'DESCRIPTIVE') {
            return <DescriptiveUpload drive={drive} course={course} configurationId={configurationId}></DescriptiveUpload>;
        } else if (examType === 'TYPING') {
            return <TypingUpload drive={drive} course={course} configurationId={configurationId}></TypingUpload>
        } else {
            return null;
        }
    }

    return (
        <>
            {renderComponent()}
        </>
    );
}